<!--
 * @Author: your name
 * @Date: 2020-09-28 19:29:53
 * @LastEditTime: 2020-11-25 16:32:03
 * @LastEditors: Zed
 * @Description: In User Settings Edit
 * @FilePath: \bidding-oa-web\src\views\components\resultTable.vue
-->
<template>
    <div>
        <div class="flexClass">
            <div class="listItemClass" v-for="(item,index) in detailList" :key="index">
                <P>套餐名称：{{item.title}}</P>
                <P>套餐价格：{{item.price}}元</P>
                <P>套餐期限：{{item.days}}天</P>
                <!-- <P>套餐权益：</P> -->
                <el-button @click="buyClick(item)" type="success">购买</el-button>
            </div>
        </div>
        <el-dialog
          title=""
          :visible.sync="dialogVisible"
          width="30%">
          <div style="text-align: center;">
            <div style="font-weight: 600;">请用微信扫一扫</div>
            <img style="width: 200px;height: 200px;margin: 10px auto;" :src="qRCodeUrl" />
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleClick">取 消</el-button>
            <el-button type="primary" @click="dialogVisibleClick">确 定</el-button>
          </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import announcement from "@/api/announcement/announcement"
  export default {
    props: {
    list: Array,
    hideHeader: Boolean
  },
    data() {
      return {
        dialogVisible: false,
        timeTag:null,
        detailList: [],
        qRCodeUrl:'',
        total: '',
        query: {
          current: 1,
          size: 7,
          projectId: ''
        },
      }
    },
    methods: {
      dialogVisibleClick(){
        this.dialogVisible=false
        clearInterval(this.timeTag)
      },
      buyClick(data){
        
        announcement.activeMember({suiteId:data.id}).then(res=>{
          console.log("获取付费信息",res)
          if(res.code==0){
            this.qRCodeUrl=res.data.codeUrl
            this.dialogVisible=true
            this.timeTag=setInterval(() => {
              announcement.pollingOrder({orderNo:res.data.orderNo}).then(res=>{
                if(res.code==0){
                  this.dialogVisible=false
                  clearInterval(this.timeTag)
                }
              })
            }, 2000);
          }else{
            this.$message.warning(res.message)
          }
          
        })
      }
      
    },
    created() {
      
    //   this.querySuiteList()
      announcement.suiteList().then(res=>{
        this.detailList=res.data
      })
    },
  }
  </script>
  
  <style lang="less" scoped>
    .flexClass{
        display: flex;
        flex-wrap: wrap;
        background: #fff;
        .listItemClass{
            width: 200px;
            margin-right: 10px;
            border-radius: 5px;
            box-shadow: 0px 0px 10px 5px #ccc;
            padding: 20px;
            padding-top: 10px;
            margin-bottom: 10px;
            cursor: pointer;
        }
    }
  </style>